const fb = require('../../../../config/firebase.js')
import Helper from "../../../../helpers/helpers";

const state = () => ({
    appStatistics: {},
    appStatisticsLoaded: false,
    lastUsers: {},
    lastUsersLoaded: false,
    topUsers: {},
    topUsersLoaded: false,
    appStatisticsByDay: {},
    appStatisticsByDayLoaded: {}
})

const getters = {}

const actions = {
    fetchAppStats({ commit, state }, payload) {
        fb.admininistrationCollection
            .doc("administration_statistics")
            .get()
            .then(function(doc) {
                if (doc.exists) commit('setAppStatistics', doc.data());
                commit('setAppStatisticsLoaded', true);
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
    },
    fetchLastUsers({ commit, state }) {
        fb.usersCollection
            .limit(5)
            .orderBy('created_at', 'desc')
            .get()
            .then(function(docSnaps) {
                docSnaps.forEach(function (doc) {
                    commit('setLastUsers', {
                        'id': doc.id,
                        'data': doc.data()
                    })
                });
                commit('setLastUsersLoaded', true);
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
    },
    fetchTopUsers({ commit, state }) {
        fb.usersCollection
            .limit(5)
            .orderBy('stats_points', 'desc')
            .get()
            .then(function(docSnaps) {
                docSnaps.forEach(function (doc) {
                    commit('setTopUsers', {
                        'id': doc.id,
                        'data': doc.data()
                    })
                });
                commit('setTopUsersLoaded', true);
            })
            .catch(function(error) {
                console.log("Error getting document:", error);
            });
    },
    fetchAppStatsByDay({ commit, state }) {
        for (let i = 0; i < 6; i++) {
            fb.admininistrationCollection
                .doc("administration_statistics")
                .collection("administration_statistics_by_date")
                .doc(Helper.retrieveDate(i).toString())
                .get()
                .then(function(doc) {
                    if (doc.exists) {
                        commit('setAppStatisticsByDay', {
                            'day': i,
                            'usersRegistered': (doc.data().user_registered != null ? doc.data().user_registered : 0),
                            'usersLogin': (doc.data().user_login != null ? doc.data().user_login : 0)
                        })
                    }
                    else {
                        commit('setAppStatisticsByDay', {
                            'day': i,
                            'usersRegistered': 0,
                            'usersLogin': 0
                        })
                    }
                    commit('setAppStatisticsByDayLoaded', true);
                })
                .catch((e) => console.log("Error getting document - :", e));
        }
    }
}

const mutations = {
    setAppStatistics(state, val) {
        state.appStatistics = val;
    },
    setAppStatisticsLoaded(state, val) {
        state.appStatisticsLoaded = val;
    },
    setLastUsers(state, val) {
        state.lastUsers[val.id] = val.data;
    },
    setLastUsersLoaded(state, val) {
        state.lastUsersLoaded = val;
    },
    setTopUsers(state, val) {
        state.topUsers[val.id] = val.data;
    },
    setTopUsersLoaded(state, val) {
        state.topUsersLoaded = val;
    },
    setAppStatisticsByDay(state, val) {
        state.appStatisticsByDay[val.day] = {
            'usersRegistered': val.usersRegistered,
            'usersLogin': val.usersLogin
        };
    },
    setAppStatisticsByDayLoaded(state, val) {
        state.appStatisticsByDayLoaded = val;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/stores/modules/pages/admin/appViewDashboard.js